import React, { ComponentProps } from 'react';

import { NavMain } from 'src/components/nav-main';
import { NavUser } from 'src/components/nav-user';
import { ProjectSwitcher } from 'src/components/project-switcher';
import {
  Sidebar,
  SidebarContent,
  SidebarFooter,
  SidebarHeader,
  SidebarRail,
} from 'src/components/ui/sidebar';
import {
  sidebarMainNavigationConfig,
  sidebarProjectsConfig,
} from 'src/sidebarConfig';

export function AppSidebar({ ...props }: ComponentProps<typeof Sidebar>) {
  return (
    <Sidebar className='bg-sidebar' collapsible='icon' {...props}>
      <SidebarHeader className='bg-sidebar'>
        <ProjectSwitcher projects={sidebarProjectsConfig} />
      </SidebarHeader>
      <SidebarContent className='bg-sidebar'>
        <NavMain items={sidebarMainNavigationConfig} />
      </SidebarContent>
      <SidebarFooter className='bg-sidebar'>
        <NavUser />
      </SidebarFooter>
      <SidebarRail />
    </Sidebar>
  );
}
